<template>
  <div class="logout">
    <div class="logout__header">
      <div class="logout__header--title">
        <img src="@/assets/logo.png" alt="logo" width="15%" />
        <strong>商情資料查詢系統</strong>
      </div>
    </div>

    <div class="logout__func">
      <div class="logout__func--infoCard">
        <label style="color:black;font-weight:700">{{ msg }}</label>
        <label style="color:black;font-weight:300">請由ePortal重新登入</label>
      </div>
    </div>

    <div class="footer">
      <!-- V05301520 -->
      <!-- <p>Copyright © 2023 minds Corporation. V0411</p> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "Logoutauto",
  data() {
    return {
      msg: "您已超過10分鐘未使用，因此自動登出!",
    };
  },
  computed: {},
  methods: {},
  mounted() {
    // 檢查是否有 msg 參數並且不為空
    if (this.$route.query.msg && this.$route.query.msg.trim() !== "") this.msg = "有相同的帳號在其他地方登入，因此自動登出!";
    else this.msg = "您已超過10分鐘未使用，因此自動登出!";
  },
};
</script>

<style lang="scss" scoped>
// * {
//   outline: red 1px solid;
// }
.logout {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  // background: linear-gradient(-45deg, transparent 55%, #191972 0) right,
  //   linear-gradient(45deg, transparent 15px, #00abb9 0) left;
  // background: linear-gradient(135deg,#E0652A 3%, #fff 50%, #FFF6EF ) center center / 100% 100%;
  //background: linear-gradient(135deg,#191970 3%, #fff 50%, #00abb9 ) center center / 100% 100%;
  background: linear-gradient(135deg, #191970 20%, #fff 50%, #fff6ef) center center / 100% 100%;

  @media (min-width: 1024px) {
    flex-direction: row;
  }

  &__header {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;

    &--title {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 5%;

      strong {
        font-size: 36px;
        letter-spacing: 5px;
        color: white;
        margin-left: 3%;
        padding: 0px 0px;
        text-shadow: black 0.1em 0.1em 0.2em;
      }
    }
  }

  &__func {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;

    @media (min-width: 450px) {
      align-items: center;
    }

    &--infoCard {
      width: 100%;
      display: flex;
      margin-top: 30%;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      label {
        min-width: 100px;
        max-width: 560px;
        font-size: 20px;
        color: white;
        letter-spacing: 10px;
      }

      button {
        width: calc(100% - 20px);
        max-width: 400px;
        background: #191970;
        padding: 4px;
        border-radius: 8px;
        font-size: 20px;
        color: white;
        font-weight: bold;
        letter-spacing: 5px;
        transition: 0.6s;
        border: 1px solid white;
        cursor: pointer;

        &:hover {
          background: #dfdff5;
          border: 1px solid #191970;
          color: #191970;
        }
      }
    }
  }

  .footer {
    position: absolute;
    bottom: 1rem;
    width: 100%;
    text-align: center;

    p {
      margin-bottom: 0;
      font-size: 18px;
      color: grey;
      letter-spacing: 2.5px;
    }
  }
}
</style>
